import React, { Component, Fragment } from "react"
import "reactjs-popup/dist/index.css"
import { Popup } from "./style.js"
import icon_user from "../../images/icons8-user-24.png"
import icon_phone from "../../images/icons8-ringing-phone-24.png"
import icon_at from "../../images/icons8-email-24.png"
import icon_file from "../../images/icons8-document-24.png"
import { Col, Container, Row } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

const img_user = {
  background: `url(${icon_user}) no-repeat scroll 15px 13px white`,
  marginBottom: "10px",
}

const img_phone = {
  background: `url(${icon_phone}) no-repeat scroll 15px 13px white`,
  marginBottom: "10px",
}

const img_at = {
  background: `url(${icon_at}) no-repeat scroll 15px 13px white`,
  marginBottom: "10px",
}

const img_file = {
  background: `url(${icon_file}) no-repeat scroll 15px 13px white`,
  marginBottom: "10px",
}

class Modal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fields: {},
      errors: {},
    }
  }

  display = () => {
    return {
      display: "none",
    }

    if (typeof window !== "undefined") {
      return {
        display: window.location.href.indexOf("/pl/") !== -1 ? "block" : "none",
      }
    } else {
      return {
        display: "block",
      }
    }
  }

  handleValidation() {
    let fields = this.state.fields
    let errors = {}
    let formIsValid = true

    //Name
    if (!fields["name"]) {
      formIsValid = false
      errors["name"] = "Proszę wpisać Imię i nazwisko"
    }

    if (typeof fields["name"] !== "undefined") {
      if (!fields["name"].match(/^[a-zżźćńółęąśA-ZŻŹĆĄŚĘŁÓŃ ]+$/)) {
        formIsValid = false
        errors["name"] = "Pole może zawierać tylko litery"
      }
    }

    //Email
    if (!fields["email"]) {
      formIsValid = false
      errors["email"] = "Wpisz swój email"
    }

    if (typeof fields["email"] !== "undefined") {
      let lastAtPos = fields["email"].lastIndexOf("@")
      let lastDotPos = fields["email"].lastIndexOf(".")

      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          fields["email"].indexOf("@@") == -1 &&
          lastDotPos > 2 &&
          fields["email"].length - lastDotPos > 2
        )
      ) {
        formIsValid = false
        errors["email"] = "Wpisz poprawny email"
      }
    }
    //Phone
    if (typeof fields["phone"] !== "undefined") {
      if (!fields["phone"].match(/^\s*\d+\s*$/i)) {
        formIsValid = false
        errors["phone"] = "Pole może zawierać tylko cyfry"
      }
    }

    this.setState({ errors: errors })
    return formIsValid
  }

  contactSubmit(e) {
    e.preventDefault()

    if (this.handleValidation()) {
      if (document.getElementById("projectName").value != "janowo") {
        window.gtag("event", "conversion", {
          send_to: "AW-761411387/jYvLCNHivt0CELvuiOsC",
        })
      } else {
        window.gtag("event", "conversion", {
          send_to: "AW-761411387/f7YlCNXXvt0CELvuiOsC",
        })
      }
      // if (window.gtag_report_ask_conversion) {
      //   window.gtag_report_ask_conversion()
      // }
      if (window.gtag_send_form_conversion) {
        window.gtag_send_form_conversion()
      }

      let fields = this.state.fields

      let formdata = new FormData()
      formdata.append("eMail", fields["email"])
      formdata.append("name", fields["name"])
      formdata.append("text", document.getElementById("message").value)
      formdata.append("phone", fields["phone"] || "-")
      formdata.append(
        "flatID",
        document.getElementsByClassName("code")[0].innerText ?? "-"
      )
      formdata.append(
        "cameFrom",
        typeof window !== "undefined" && sessionStorage.getItem("refferer")
      )
      let requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      }
      fetch(
        "https://panel.willbud.pl/upload_from_external_server/",
        requestOptions
      )
        .then(response => response.text())
        .then(result => console.log("RESULT", result))
        .catch(error => console.log("error", error))

      fetch("https://willbud.pl/form-process.php", {
        method: "POST",
        body: JSON.stringify({
          modal_type: "Question",
          name: fields["name"],
          phone: fields["phone"],
          message: document.getElementById("message").value,
          email: fields["email"],
          flatID: document.getElementsByClassName("code")[0].innerText,
        }),
        mode: "cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
      })
        .then(res => {
          document.getElementById("myModal").style.display = "none"
        })
        .catch(err => console.log(err))
    } else {
    }
  }

  handleChange(field, e) {
    let fields = this.state.fields
    fields[field] = e.target.value
    this.setState({ fields })
  }

  /*
    validateemail = (email) => {
        var reg = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)

        if (!reg.test(email)) {
            return false;
        } else {
            return true;
        }
    }*/

  /*handledateChange = () => {
        let input = document.getElementById('adres_email');

        if (this.validateemail(input.value)) {
            fetch("http://test8.willbud.pl/form-process.php", {
                method: "POST",
                body: JSON.stringify({
                    'modal_type': 'Question',
                    'message': input.value,
                    'email': input.value
                }),
                mode: "cors",
                cache: "no-cache",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                redirect: "follow",
                referrer: "no-referrer",
            }).then(res => {
                    document.getElementById("myModal").style.display = "none";
            }).catch(err => console.log(err))
        } else {
            return alert ("You have entered an invalid email address!")
        }
    }*/

  render() {
    function closest(el, selector) {
      var matchesFn
      ;[
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function(fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn
          return true
        }
        return false
      })

      var parent

      while (el) {
        parent = el.parentElement
        if (parent && parent[matchesFn](selector)) {
          return parent
        }
        el = parent
      }

      return null
    }

    if (typeof document !== "undefined") {
      document.addEventListener("mousedown", function(e) {
        if (
          closest(e.target, "#myModal") === null ||
          closest(e.target, ".modalheader") !== null
        ) {
          const modal = document.getElementById("myModal")
          if (modal) {
            modal.style.display = "none"
          }
        }
      })

      window.addEventListener("load", () => {
        document
          .getElementById("sendMail")
          .addEventListener("click", function() {})
      })
    }

    return (
      <Fragment>
        <Popup>
          <div id="myModal" className="modal" style={this.display()}>
            <Container>
              <Row>
                <Col id="divContainer" xs={12} md={12} lg={12}>
                  <div className="modal-content  ">
                    <div className={"modalheader"}>
                      <button
                        type="button"
                        className={"btn btn-circle close_x"}
                      >
                        <i>
                          <FontAwesomeIcon
                            icon={faTimes}
                            color="white"
                            size="lg"
                          />
                        </i>
                      </button>
                    </div>
                    <div className={"slogan"}>
                      <h1> Wyślij zapytanie</h1>
                    </div>
                    <form
                      name="contactform"
                      className="contactform"
                      onSubmit={this.contactSubmit.bind(this)}
                    >
                      <input type="hidden" id="projectName" />
                      <Row>
                        <Col xs={12} lg={6}>
                          <div className={"inputDiv"}>
                            <input
                              className={"input"}
                              placeholder="Imię i nazwisko"
                              ref="name"
                              type="text"
                              style={img_user}
                              onChange={this.handleChange.bind(this, "name")}
                              value={this.state.fields["name"]}
                            />
                            <span style={{ color: "red" }}>
                              {this.state.errors["name"]}
                            </span>
                          </div>
                          <div className={"inputDiv"}>
                            <input
                              className={"input"}
                              placeholder="Nr telefonu"
                              refs="phone"
                              type="text"
                              style={img_phone}
                              onChange={this.handleChange.bind(this, "phone")}
                              value={this.state.fields["phone"]}
                            />
                            <span style={{ color: "red" }}>
                              {this.state.errors["phone"]}
                            </span>
                          </div>
                          <div className={"inputDiv"}>
                            <input
                              className={"input"}
                              placeholder="Adres e-mail"
                              refs="email"
                              type="email"
                              style={img_at}
                              onChange={this.handleChange.bind(this, "email")}
                              value={this.state.fields["email"]}
                            />
                            <span style={{ color: "red" }}>
                              {this.state.errors["email"]}
                            </span>
                          </div>
                        </Col>
                        <Col xs={12} lg={6}>
                          <div className={"textarea"} style={img_file}>
                            <p className={"textarea"}> Treść wiadomości</p>
                            <p className={"code"}>OJP/B07/P0/M05</p>
                          </div>
                          <textarea
                            className={"textarea"}
                            placeholder="Napisz coś..."
                            id={"message"}
                            name="message"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} lg={6}>
                          <div style={{ width: "100%" }}>
                            <p className={"rodo_consent"}>
                              Wyrażam zgodę na używanie przez Willbud sp. z o.
                              o. sp. k. danych osobowych do celów marketingu
                              oraz w celu bezpośredniego przesyłania informacji
                              handlowych drogą elektroniczną dotyczących ofert
                              firmy.
                            </p>
                          </div>
                        </Col>
                        <Col xs={12} lg={6}>
                          <button
                            className={"sendMail"}
                            id={"sendMail"}
                            onClick={this.contactSubmit.bind(this)}
                          >
                            Wyślij
                          </button>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Popup>
      </Fragment>
    )
  }
}

export default Modal
